<div class="pre-prestador-dashboard">
    <div class="pre-prestador-detalhe-card">
        <app-pessoa-detalhe #pessoaDetalhe [pessoa]="pessoa"></app-pessoa-detalhe>
    </div>

    <div class="pre-prestador-conteudo">
        <div class="grid-debitos">
            <p-card class="pre-prestador-card">
                <div class="dashboard-card-header">
                    <div class="dashboard-card-title">
                        <i class="pi pi-building" aria-hidden="true"></i>
                        <span>Pr&eacute;-prestador</span>
                    </div>
                    <p-select [appendTo]="'body'" [options]="options" [(ngModel)]="selectedComponent" optionLabel="name" placeholder="Selecione" class="w-full md:w-56" />
                </div>

                @if (selectedComponent.value === 'anexos') {
                    <div class="content mt-4">
                        @if (anexos.length > 0) {
                            <div class="anexos-grid">
                                @for (anexo of anexos; track anexo.label) {
                                    <div class="anexo-card">
                                        <div class="anexo-card-header">
                                            <i class="pi pi-paperclip" aria-hidden="true"></i>
                                            <span>{{ anexo.label }}</span>
                                        </div>
                                        <div class="anexo-card-value">{{ anexo.valor }}</div>
                                    </div>
                                }
                            </div>
                        } @else {
                            <div class="text-500 italic">Nenhum anexo encontrado para este pr&eacute;-prestador.</div>
                        }
                    </div>
                } @else {
                    <div class="content">TODO: implementar</div>
                }
            </p-card>
        </div>
    </div>
</div>
